import { FiltersPanelActions } from "../../../../common/components/filters/FiltersPanelActions";
import { SelectField } from "../../../../common/components/forms/inputs/dropdown/SelectField";
import {
  RATING_FILTER_OPTIONS,
  VISIBILITY_FILTER_OPTIONS,
  VISIBILITY_HIDDEN,
  VISIBILITY_VISIBLE,
} from "../hooks/useStudioReviewsPage";
import styles from "./ReviewsFiltersPanelContent.module.scss";

interface IReviewsFiltersPanelContentProps {
  ratingFilter: number | null;
  hiddenFilter: boolean | null;
  onRatingChange: (rating: number | null) => void;
  onHiddenChange: (isHidden: boolean | null) => void;
  onClearAll: () => void;
  onClose: () => void;
}

const toVisibilityValue = (isHidden: boolean | null) => {
  if (isHidden === null) {
    return undefined;
  }
  return isHidden ? VISIBILITY_HIDDEN : VISIBILITY_VISIBLE;
};

/**
 * The "Ревюта" filters side panel: rating and visibility on the site. Two short
 * fields, so their names sit inside them as labels instead of section headings.
 */
export const ReviewsFiltersPanelContent = ({
  ratingFilter,
  hiddenFilter,
  onRatingChange,
  onHiddenChange,
  onClearAll,
  onClose,
}: IReviewsFiltersPanelContentProps) => (
  <div className={styles.root}>
    <div className={styles.root_fields}>
      <SelectField
        label="Оценка"
        options={RATING_FILTER_OPTIONS}
        value={ratingFilter ?? undefined}
        onChange={(value) => onRatingChange(value || null)}
        defaultValue="Всички оценки"
        width="100%"
        includeId={false}
      />

      <SelectField
        label="Видимост"
        options={VISIBILITY_FILTER_OPTIONS}
        value={toVisibilityValue(hiddenFilter)}
        onChange={(value) =>
          onHiddenChange(value ? value === VISIBILITY_HIDDEN : null)
        }
        defaultValue="Всички ревюта"
        width="100%"
        includeId={false}
      />
    </div>

    <FiltersPanelActions onApply={onClose} onClearAll={onClearAll} />
  </div>
);
